// Single source of truth for colors needed as JS values (inline styles,
// canvas/SVG props, third-party component config). tailwind.config.js imports
// these same constants for the matching theme keys, so editing a value here
// changes both the utility classes and the programmatic uses together.

export const brand = {
  primary: '#FF6B35',
  success: '#00B894',
  error: '#E17055',
  white: '#FFFFFF',
  dark: '#2D3436',
  darkLight: '#636E72',
};

// Programmatic uses of the stock scales (animations); values match the
// pinned scales in tailwind.config.js.
export const stock = {
  info500: '#3b82f6',
  neutral800: '#1f2937',
};
